export default "__VITE_ASSET__DeA95qcY__"